"use client";

import { useEffect, useState } from "react";
import { getTaxonomyItems } from "@/lib/taxonomy-cache";

export type DiscoverTcgRow = {
  id: string;
  slug: string;
  name: string;
  sort_order: number | null;
};

export function useDiscoverTcgs() {
  const [tcgs, setTcgs] = useState<DiscoverTcgRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getTaxonomyItems({ type: "tcg", parent: { mode: "root" } });
        if (cancelled) return;
        const rows: DiscoverTcgRow[] = data
          .filter((row) => typeof row.slug === "string" && row.slug.length > 0)
          .map((row) => ({ id: row.id, slug: row.slug as string, name: row.name, sort_order: row.sort_order }));
        const deduped = Array.from(
          new Map(rows.map((row) => [row.slug.trim().toLowerCase(), row])).values()
        );
        setTcgs(deduped);
      } catch (err) {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : "Failed to load TCGs");
        setTcgs([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { tcgs, isLoading, error };
}
